module.exports = __webpack_public_path__ + "img/aeon-deltamas.87c26abc.jpg";